import { render, staticRenderFns } from "./ParamInfo.vue?vue&type=template&id=280a02be"
import script from "./ParamInfo.vue?vue&type=script&lang=js"
export * from "./ParamInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports